import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'speak-to-sales-popover',
  templateUrl: './speak-to-sales-popover.component.html',
  styleUrls: ['./speak-to-sales-popover.component.css'],
})
export class SpeakToSalesPopoverComponent implements OnInit {
  @Input()
  inputParams: any = {
    isShown: false,
    sectionTitle: '',
    doubleHeight: false,
    noPadding: false,
  };
  constructor() {}

  ngOnInit() {}
}
